/**
 * Authentication Service
 * Handles JWT token storage and authentication state management
 */

const TOKEN_KEY = 'halo_admin_token';

export const authService = {
  /**
   * Store JWT token in localStorage
   * @param {string} token - The JWT token
   */
  setToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
  },

  /**
   * Get JWT token from localStorage
   * @returns {string|null} - The token or null if not found
   */
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  /**
   * Remove JWT token from localStorage
   */
  clearToken() {
    localStorage.removeItem(TOKEN_KEY);
  },

  /**
   * Check if user is authenticated and token is not expired
   * @returns {boolean} - True if authenticated
   */
  isAuthenticated() {
    const token = this.getToken();
    if (!token) return false;

    try {
      // Decode JWT payload (second part of token)
      const payload = JSON.parse(atob(token.split('.')[1]));

      // Check if token is expired
      const expiresAt = payload.exp * 1000; // Convert to milliseconds
      return Date.now() < expiresAt;
    } catch (error) {
      // Invalid token format
      return false;
    }
  },

  /**
   * Clear token (logout)
   */
  logout() {
    this.clearToken();
  }
};
